module.exports = __webpack_public_path__ + "img/yejian.5e0369c3.png";